import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDefaultRoute } from '../utils/getDefaultRoute';
import { isReportingIntelligenceUiEnabled } from '../config/reportingIntelligenceFlags';

/**
 * Blocks RI route shell when the client flag is OFF.
 * Matches nav visibility — no URL bypass. Server still 404s when master flag is off.
 */
export function RequireReportingIntelligence({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!isReportingIntelligenceUiEnabled()) {
    return <Navigate to={getDefaultRoute(user.role, user)} replace />;
  }
  return children;
}
